module.exports = __webpack_public_path__ + "static/media/B_S03.4fad4896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/B_S03.png
// module id = 93
// module chunks = 0